import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  DamLeveeFailureIcon,
  HazmatIcon,
  HazardIcon,
  RoadWashoutIcon,
  StandingWaterIcon,
  SwiftWaterIcon,
} from 'features/mapping/icons';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const HazardsLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle>
          {t('map.legends.hazards.title')}
        </LegendSectionTitle>
      }
    >
      <LegendListItem
        iconSrc={SwiftWaterIcon.data}
        primaryText={t('map.legends.hazards.legends.swiftWater.title')}
        secondary={t('map.legends.hazards.legends.swiftWater.subtitle')}
      />
      <LegendListItem
        iconSrc={StandingWaterIcon.data}
        primaryText={t('map.legends.hazards.legends.standingWater.title')}
        secondary={t('map.legends.hazards.legends.standingWater.subtitle')}
      />
      <LegendListItem
        iconSrc={RoadWashoutIcon.data}
        primaryText={t('map.legends.hazards.legends.roadWashout.title')}
        secondary={t('map.legends.hazards.legends.roadWashout.subtitle')}
      />
      <LegendListItem
        iconSrc={DamLeveeFailureIcon.data}
        primaryText={t('map.legends.hazards.legends.damLeveeFailure.title')}
        secondary={t('map.legends.hazards.legends.damLeveeFailure.subtitle')}
      />
      <LegendListItem
        iconSrc={HazmatIcon.data}
        primaryText={t('map.legends.hazards.legends.hazmat.title')}
        secondary={t('map.legends.hazards.legends.hazmat.subtitle')}
      />
      <LegendListItem
        iconSrc={HazardIcon.data}
        primaryText={t('map.legends.hazards.legends.other.title')}
        secondary={t('map.legends.hazards.legends.other.subtitle')}
      />
    </List>
  );
};
